module.exports = __webpack_public_path__ + "static/media/default_cover_music.a2a5c35a.png";